module.exports = __webpack_public_path__ + "img/logo-icon.c2bc0eec.png";